import { render } from "./WithSwiper.vue?vue&type=template&id=e7b5b86c&scoped=true"
import script from "./WithSwiper.vue?vue&type=script&lang=js"
export * from "./WithSwiper.vue?vue&type=script&lang=js"

import "./WithSwiper.vue?vue&type=style&index=0&id=e7b5b86c&scoped=true&lang=css"
import "./WithSwiper.vue?vue&type=style&index=1&id=e7b5b86c&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7b5b86c"]])

export default __exports__